import { Injectable } from "@angular/core";
import { PagingRequest } from "../../models/domains/paginator/paging-request";

import { Practitioner } from "../../models/domains/pbm/practitioner-management/practitioner";
import { PractitionerSpecialty } from "../../models/domains/pbm/practitioner-management/practitioner-specialty";
import { PractitionerStatus } from "../../models/domains/pbm/practitioner-management/practitioner-status";
import { SearchPractitionerRequest } from "../../models/domains/pbm/practitioner-management/search-practitioner.request";
import { SearchPractitionerResult } from "../../models/domains/pbm/practitioner-management/search-practitioner.result";
import { PractitionerManagementRepository } from "../../repositories/pbm/practitioner-management.repository";

@Injectable({ providedIn: "root" })
export class PractitionerManagementService {
  constructor(private practitionerManagementRepository: PractitionerManagementRepository) {}

  public async searchPractitioners(request: SearchPractitionerRequest): Promise<SearchPractitionerResult> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.searchPractitioners(request));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async searchPractitionerByKey(key: string): Promise<Practitioner> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.searchPractitionerByKey(key));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async registerPractitioner(practitioner: Practitioner): Promise<string> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.registerPractitioner(practitioner));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async editPractitioner(practitioner: Practitioner): Promise<void> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.editPractitioner(practitioner));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async deletePractitioner(practitioner: Practitioner): Promise<void> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.deletePractitioner(practitioner));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getSpecialties(request: PagingRequest): Promise<PractitionerSpecialty[]> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.getSpecialties(request));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAllPractitionerStatus(): Promise<PractitionerStatus[]> {
    try {
      return Promise.resolve(await this.practitionerManagementRepository.getAllPractitionerStatus());
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
